import { Box, Button, styled, Typography } from '@mui/material';

export const ScheduleComponentLayoutWrapper = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const LayoutScreensWrapper = styled(Box)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const ScheduleNameHeader = styled(Typography)`
  display: flex;
  align-items: center;
  font-size: 28px;
  padding-right: 16px;
`;
export const ScheduleHeaderRow = styled(Box)(
  ({ $showScheduleName }) => `
  display: flex;
  align-items: center;
  justify-content: ${$showScheduleName ? 'space-between' : 'flex-end'};
  margin-bottom: 12px;
  height: 42px;
  `,
);
export const HeaderActionButton = styled(Button)`
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-right: 20px;
`;
